<template>
  <atendantForm :typeEndPoint="'academicCoursesEdit'" :dataParams="this.$route.params" />
</template>
<script>
import atendantForm from '@/components/modules/academic/courses/form'
export default {
  name: 'academicCoursesEdit',
  components: {
    atendantForm
  },
  mounted () {
    console.log(this.$route.params)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modules/academic/courses/edit.vue